<template>
  <PlanDocument
    :frameworks="frameworks"
    :plan="plan"
    :nodes="planStore.nodes"
    :edges="planStore.edges"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { PlanDocument } from '@/components/plan/index.js';

import { usePlanStore } from '@/store/index.js';

defineProps({
  frameworks: {
    type: Array,
    default: () => null,
  },
});

const planStore = usePlanStore();
const route = useRoute();
const plan = computed(() => {
  return {
    id: planStore.id,
    name: planStore.name,
    description: planStore.description,
    introduction: planStore.introduction,
    executiveSummary: planStore.executiveSummary,
    conclusion: planStore.conclusion,
    vision: planStore.vision,
    nodes: planStore.nodes,
    edges: planStore.edges,
    lastPublishedAt: planStore.lastPublishedAt,
    logo: planStore.logo,
    district: planStore.district,
  };
});
</script>
